import React, { ReactElement } from 'react';
import { Button, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Text, Image } from '@chakra-ui/react';

const SuccessModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string | ReactElement;
}): ReactElement => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay bg="transparentGray.100" />
      <ModalContent borderRadius="lg" overflow="hidden">
        <ModalBody p="0">
          <Flex
            w="full"
            h="full"
            px="16"
            py="10"
            direction="column"
            justifyContent="center"
            alignItems="center"
            gridGap="4"
            bg="linear-gradient(180deg, #D4DFF7 -15.71%, rgba(212, 223, 247, 0) 69.95%)"
          >
            <Image src="/assets/icons/publish.svg" mb={4} />

            <Text fontSize="md" fontWeight="500" color="gray.800">
              {title}
              <span role="img" aria-label="emoji">
                {' '}
                🎉
              </span>
            </Text>

            {subtitle && (
              <Text fontSize="sm" fontWeight="normal" color="gray.600" textAlign="center">
                {subtitle}
              </Text>
            )}
          </Flex>
        </ModalBody>
        <ModalFooter p="6">
          <Flex justifyContent="center" w="full">
            <Button
              borderRadius="lg"
              fontSize="sm"
              fontWeight="normal"
              borderWidth={1}
              borderColor="gray.200"
              bg="white.50"
              onClick={onClose}
            >
              Close
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SuccessModal;
